import React, { Component } from 'react';
import Config from './SkillsConfig'

import './Layout';

class Skills extends Component {
    renderLanguages() {
        const languages = Config.Languages.map((l) => {
            return(
                <li>
                  <i className="fa-li fa fa-check"></i>
                  {l}
                </li>
            );
        });

        return (
            <div className="w-100">
                <h2 className="mb-5">Skills</h2>
                <div className='subheading mb-3'>
                    Programming Languages
                    <ul className="fa-ul mb-0"> {languages} </ul>
                </div>
                
            </div>
        );
    }

    renderTools(){
        const tools = Config.Tools.map((t) => {
            return(
                <li className="list-inline-item">
                    <i class={t}></i>
                    </li>
            )
        });

        return(
            <div className="subheading mb-3">
                Tools

                <ul className="list-inline dev-icons">
                    {tools}
                </ul>
            </div>
        );
    }


    render(){
        return(
            <div className="w-100">
            <>{this.renderLanguages()}</>
            <>{this.renderTools()}</>
            </div>
        );
    }
}

export default Skills;